import service from '@/util/service';

// bid
export const getBidList = params => service.jsonGet('/api/bid/list', params);

export const getBidInfo = params => service.jsonGet('/api/bid/info', params);

export const getBidTopTeam = params => service.jsonGet('/api/bid/topTeam', params);

export const getBidTeamList = params => service.jsonGet('/api/bid/teamList', params);

export const getBidWorkerList = params => service.jsonGet('/api/bid/workerList', params);



// WEBPACK FOOTER //
// ./src/api/bid/index.js